import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    Label,
    Row,
    
} from "reactstrap";
import Select from "react-select";
import Breadcrumbs from "components/Common/BreadcrumbTitle";

import * as Yup from "yup";
import { useFormik } from "formik";
import CommonDialog from "components/Common/CommonDialog";
import ToastDialog from "components/Common/ToastDialog";

import { addUser, editUser, getUserByID } from "http/fundLync/user.helper";

import { getRoleByEntityType } from "../../http/fundLync/role.helper"
import { getCIUser, getOwnerID } from "../../http/fundLync/entityAndAddress.helper";
import { useToast } from "ToastStore";
import { decryptedValue } from "common/utility";

const AddOrEditCIUser = () => {
    const [roleList, setRoleList] = useState([])
    const [ownerID, setOwnerID] = useState(null)
    const [user, setUser] = useState({})
    const [managerList, setManagerList] = useState([])
    const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const navigate = useNavigate();

    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)
    
    const { handleToastData } = useToast();

    document.title = encodedId ? "Edit CI User | Fundync" : "Add CI User | Fundync"

    useEffect(() => {
        if (encodedId) {
            getUserByID({ id: decodedId })
                .then(responseFromAPI => {
                    if (responseFromAPI.status && responseFromAPI.code == 200) {
                        setUser(responseFromAPI.data)
                    }
                })
                .catch(error => { })
        }

        getRoleByEntityType({ searchKey: 'Owner' })
            .then(responseFromAPI => {
                if (responseFromAPI.status && responseFromAPI.code == 200) {
                    setRoleList(responseFromAPI.data.data)
                }
            })
            .catch(error => { })

        getOwnerID()
            .then(responseFromAPI => {
                if (responseFromAPI.status && responseFromAPI.code == 200) {
                    setOwnerID(responseFromAPI.data.id)
                }
            })
            .catch(error => { })

         getCIUser()
            .then(responseFromAPI => {
                if (responseFromAPI.status && responseFromAPI.code == 200) {
                    const totalItems = responseFromAPI.data.totalItems
                    getCIUser({limit : totalItems})
                    .then(responseFromAPI => {
                        if (responseFromAPI.status && responseFromAPI.code == 200) {
                            setManagerList(responseFromAPI.data.data)
                        }
                    })
                    .catch(error => { })
                    
                }
            })
            .catch(error => { })
    }, [])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            firstName: user.firstName || "",
            lastName: user.lastName || "",
            email: user.email || "",
            mobileNo: user.mobileNo || "",
            reportingManagerId: user.reportingManagerId || null,
            roleId: user.roleId || "",
            
        },

        validationSchema: Yup.object({
            firstName: Yup.string().required("Please Enter First Name"),
            lastName: Yup.string().required("Please Enter Last Name"),
            email: Yup.string().required("Please Enter Email"),
            mobileNo: Yup.string()
                .required("Please Enter Mobile No")
                .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
            roleId: Yup.string().required("Select role type")
        }),

        onSubmit: (values) => {
            const message = encodedId ? 'Are you sure want to edit user?' : 'Are you sure want to add user?'
            setShowCommonDialog({ isShow: true, message })
        }
    });

    const handleCancel = () => {
        navigate(-1)
    }

    const submitUser = () => {
        const userData = decryptedValue(localStorage.getItem("user"));
        const { values } = validation
        const user = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobileNo: String(values.mobileNo),
            reportingManagerId: values.reportingManagerId,
            roleId: values.roleId,
            entityId: ownerID
        }
        if (encodedId) {
            user['id'] = decodedId;
                editUser(user)
                    .then(responseFromAPI => {
                        if (responseFromAPI.status && responseFromAPI.code == 201) {
                            handleToastData(`${responseFromAPI.message}`, "success")
                            validation.resetForm()
                            navigate(`/${userData.roleName}/listCIUser`);
                        } else {
                            setToastInfo({
                                message: responseFromAPI.message,
                                showToast: true,
                                role: "error",
                            });
                        }
                    })
                    .catch(error => { })
        } else {
            addUser(user)
                .then(responseFromAPI => {
                    if (responseFromAPI.status) {
                        handleToastData(responseFromAPI.message, "success")
                        validation.resetForm()
                        navigate(`/${userData.roleName}/listCIUser`);
                    } else {
                        setToastInfo({
                            message: responseFromAPI.message,
                            showToast: true,
                            role: "error",
                        });
                    }
                })
                .catch(error => { })
        }

    }

    const dialogAction = (action, data) => {
        if (action == 1) {
            setShowCommonDialog({ isShow: false })
            submitUser()
        } else {
            setShowCommonDialog({ isShow: false })
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="vertical-scroll">
                <Breadcrumbs title={encodedId ? "Edit CI User" : "Add CI User"} />
                    <div>
                        <div>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col sm="12" md="6">
                                        <Label className="form-label">First Name*</Label>
                                        <Input
                                            name="firstName"
                                            type="text"
                                            placeholder="Enter First Name"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.firstName || ""}
                                            invalid={
                                                validation.touched.firstName &&
                                                validation.errors.firstName
                                            }
                                        />
                                        {validation.touched.firstName &&
                                            validation.errors.firstName ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.firstName}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label">Last Name*</Label>
                                        <Input
                                            name="lastName"
                                            type="text"
                                            placeholder="Enter Last Name"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.lastName || ""}
                                            invalid={
                                                validation.touched.lastName &&
                                                validation.errors.lastName
                                            }
                                        />
                                        {validation.touched.lastName &&
                                            validation.errors.lastName ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.lastName}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Email*</Label>
                                        <Input
                                            name="email"
                                            type="email"
                                            placeholder="Enter Email"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.email || ""}
                                            invalid={
                                                validation.touched.email &&
                                                validation.errors.email
                                            }
                                        />
                                        {validation.touched.email &&
                                            validation.errors.email ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.email}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Mobile No.*</Label>
                                        <Input
                                            name="mobileNo"
                                            type="number"
                                            placeholder="Enter Mobile No"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.mobileNo || ""}
                                            invalid={
                                                validation.touched.mobileNo &&
                                                validation.errors.mobileNo
                                            }
                                        />
                                        {validation.touched.mobileNo &&
                                            validation.errors.mobileNo ? (
                                            <FormFeedback type="invalid">
                                                {validation.errors.mobileNo}
                                            </FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Role Type*</Label>
                                        <Input
                                            name="roleId"
                                            type="select"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.roleId || ""}
                                            invalid={validation.touched.roleId && validation.errors.roleId}
                                        >
                                            <option value="" disabled>Select Role Type</option>
                                            {roleList.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.displayName}
                                                </option>
                                            ))}
                                        </Input>
                                        {validation.touched.roleId && validation.errors.roleId ? (
                                            <FormFeedback type="invalid">{validation.errors.roleId}</FormFeedback>
                                        ) : null}
                                    </Col>

                                    <Col sm="12" md="6">
                                        <Label className="form-label mt-4">Reporting Manager</Label>
                                        <Input
                                            name="reportingManagerId"
                                            type="select"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.reportingManagerId || ""}
                                        >
                                            <option value="" disabled>Select Reporting Manager</option>
                                            {managerList.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.firstName} {option.lastName}
                                                </option>
                                            ))}
                                        </Input>
                                    </Col>

                                </Row>
                                <Col className="mt-4">
                                    <div className="d-flex gap-3 justify-content-end">
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success save-customer"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </Col>
                            </Form>
                        </div>
                    </div>
                </Container>
            </div>
            {
                showCommonDialog &&
                <CommonDialog
                    isShow={showCommonDialog.isShow}
                    message={showCommonDialog.message} data={showCommonDialog.data}
                    postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}
                />
            }
            <ToastDialog
                message={toastInfo.message}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            />
        </React.Fragment>

    )
}

export default AddOrEditCIUser
